/**
 * True if any part of the element overlaps the viewport. Used to decide whether the coachmark needs a
 * "Show me" button — it only appears once the highlighted target has scrolled out of view.
 */
export function isInViewport(
  el: Pick<Element, 'getBoundingClientRect'>,
  viewportW: number = window.innerWidth,
  viewportH: number = window.innerHeight,
): boolean {
  const r = el.getBoundingClientRect();
  return r.bottom > 0 && r.right > 0 && r.top < viewportH && r.left < viewportW;
}
